import { memo } from "react"

import { useLanguage } from "assets/languages"
import CampaignFormFieldGroup from "../../../../../campaignFormFieldGroup/campaignFormFieldGroup"

const CleanVideoFieldGroup = () => {
  const language = useLanguage()
  const languageTexts = { ...language.pages.campaigns }

  return (
    <CampaignFormFieldGroup label={`6. ${languageTexts.create_reels_form_video_clean_title}`} bordered>
      <p className="text-[15px]">{languageTexts.create_reels_form_video_clean_download_desc}</p>
    </CampaignFormFieldGroup>
  )
}

export default memo(CleanVideoFieldGroup)
